// Copyright 2020 Sorama B.V.

import { IWorkflowModuleConfig } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModeType } from "services/WorkflowModes/WorkflowModes";

export enum GuidanceTopicType {
    Question,
    WorkflowHelp,
    ModuleHelp,
    UiElementHelp,
    TopicOverview,
}

export interface IGuidanceParent {
    title: string;
    overviewPage: IGuidanceTopic;
}

export interface IGuidanceTopic extends IWorkflowModuleConfig {
    topicType: GuidanceTopicType;
    topicContent: string;

    /**
     * Optional parent of this article. Primary use for the breadcrumb bar
     */
    topicParent?: IGuidanceTopic;

    /**
     * For which workflow mode this article is relevant (and should be shown)
     * If empty it is always relevant
     */
    relevantWorkflowModes?: WorkflowModeType[];

    /**
     * Planned to be used with searching
     */
    catchwords?: string[];

    hidden?: boolean;
}
